import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@air/primitive-chip";
import { memo } from "react";
export const VersionChip = /*#__PURE__*/ memo((param)=>{
    let { children, color = "grey" } = param;
    return /*#__PURE__*/ _jsx(Chip, {
        color: color,
        appearance: "filled",
        size: "small",
        children: children
    });
});
VersionChip.displayName = "VersionChip";
